module.exports = __webpack_public_path__ + "static/img/pikesi.bca8416e.png";